<template>
  <section>
    <el-table
      v-if="type === 'phone'"
      key="phone"
      :data="tableData"
      :show-header="false"
      style="width: 100%">
      <el-table-column>
        <template #default="{row}">
          <router-link
            :to="linkToCustomer(row)"
            class="name">
            <span v-if="typeof row.isrd_nm == 'string' && row.isrd_nm.trim()">{{row.isrd_nm}}</span>
            <span
              v-else
              class="unname">Unnamed Account</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile_no"
        align="right"></el-table-column>
    </el-table>

    <el-table
      v-if="type === 'email'"
      key="email"
      :data="tableData"
      :show-header="false"
      style="width: 100%">
      <el-table-column>
        <template #default="{row}">
          <router-link
            :to="linkToCustomer(row)"
            class="name">
            <span v-if="typeof row.isrd_nm == 'string' && row.isrd_nm.trim()">{{row.isrd_nm}}</span>
            <span
              v-else
              class="unname">Unnamed Account</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="email"
        align="right"></el-table-column>
    </el-table>

    <el-table
      v-if="type === 'subscribers'"
      key="subscribers"
      :show-header="false"
      :data="tableData"
      style="width: 100%">
      <el-table-column prop="email"></el-table-column>
      <el-table-column width="150">
        <template #default="{row}">
          <span
            class="span-status green"
            :class="{'red': row.status == 0}">{{row.status_language}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_date"
        align="right"></el-table-column>
      <el-table-column width="150">
        <template #default="{ row }">
          <span
            class="color-primary pointer"
            @click="subsribe(row)"
          >{{row.status==0?'Resubscribe':' Unsubscribe'}}
          </span>
        </template>
      </el-table-column>
    </el-table>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {exportEmailList, exportPhoneList, getEmailList, getPhoneList} from '@/api/news'
import {exportSubscribeList, getNesLetterList, resubscribe, unsubscribe} from '@/api/newsletter'
import {downloadFile} from '@/utils/download'
import {exportMarketingList} from '@api/marketing'

export default {
  name: '',
  props:{
    type: {
      type: String,
      default: 'phone'
    },
    marketingComm: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading:false,
      tableData: [],
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(val, old){
        if(val != old){
          this.getTabaleData()
        }
      }
    },
  },
  mounted(){
    this.getTabaleData()
  },
  methods: {
    linkToCustomer(row){
      return ({
        path: '/accounts/detail',
        query: {
          customer_id: row.customer_id,
        },
      })
    },
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    getTabaleData(params){
      this.network().getList(params)
    },
    subsribe(row){
      const {status, email} = row
      let params = {
        email,
      }
      status==0? this.network().resubscribe(params) : this.network().unsubscribe(params)
    },
    exportCSV(params){
      this.network().exportList(params)
    },
    network(){
      return{
        getList: async (params) =>{
          switch(this.type){
            case 'phone':
              var {data} = await getPhoneList({
                page: this.pageConfig.currentPage,
                marketing_comm:this.marketingComm,
                ...params
              })
              break
            case 'email':
              var {data} = await getEmailList({
                page: this.pageConfig.currentPage,
                marketing_comm:this.marketingComm,
                ...params
              })
              break
            case 'subscribers':
              var { data } = await getNesLetterList({
                page: this.pageConfig.currentPage
              })
          }
          this.tableData = data.data
          this.pageConfig.total = data.total
        },

        resubscribe: async (params) => {
          const { data } = await resubscribe(params)
          if(data.code==1000){
            this.$message({
              type:'success',
              message:data.message
            })
            this.getTabaleData()
          }
        },

        unsubscribe: async (params) => {
          const { data } = await unsubscribe(params)
          if(data.code==1000){
            this.$message({
              type:'success',
              message:data.message
            })
            this.getTabaleData()
          }
        },

        exportList: async (params) =>{
          params = {
            ...params
          }
          // this.loading = this.$loading({
          //   lock: true,
          //   text: 'Exporting...',
          //   spinner: 'el-icon-loading',
          //   background: 'rgba(0, 0, 0, 0.7)'
          // })

          switch(this.type){
            case 'phone':
              params.report_type = 8
              break
            case 'email':
              params.report_type = 9
              break
            case 'subscribers':
              params.report_type = 10
              break
          }
          const res = await this.network().exportMarketingList({...params,hideLoading: true})
        },
        exportMarketingList: async (params) => {
          const res = await exportMarketingList(params)
          this.$message({
            type: 'success',
            message: 'Exporting...'
          })
          // setTimeout(() => {
          //   this.loading.close()
          // }, 200)
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/ .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  td{
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    .cell{
      height: 20px;
      line-height: 20px;
      padding: 0 15px;
    }
  }
}
.name{
  text-decoration: none;
  color: #0366D6;
}
.span-status{
  border-radius: 100px;
  padding: 1px 8px;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 12px;
  &.green{
    background: #28A745;
  }
  &.red{
    background: #D73A49;
  }
}
</style>
